<template>
  <v-data-table
    :headers="headers"
    :items="listKasbonApproval"
    sort-by="no"
    dense
    @click:row="onClickRow"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="success" v-on="on" dark rounded :to="{ name: 'Create Kasbon Approval' }">
              <v-icon>
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <span>Create</span>
        </v-tooltip>
      </v-toolbar>
    </template>
    <template v-slot:item.no="{ item }">
      {{ listKasbonApproval.map(x => x).indexOf(item) + 1 }}
    </template>
    <template v-slot:item.employeeCount="{ item }">
      {{ item.employees ? item.employees.length : 0 }}
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">
        Reset
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    headers: [
      {
        text: "No",
        align: "center",
        sortable: false,
        value: "no",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "Department",
        value: "departmentName",
        sortable: false,
        divider: true,
        align: "center",
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "Type",
        value: "type",
        sortable: false,
        divider: true,
        align: "center",
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "Employee Count",
        value: "employeeCount",
        sortable: false,
        divider: true,
        align: "center",
        class: "light-blue lighten-2 font-weight-black",
      },
    ],
  }),

  computed: {
    ...mapState("kasbonApproval", ["listKasbonApproval"]),
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch("kasbonApproval/getAll");
    },
    onClickRow(item) {
      this.$router.push({ name: "Detail Kasbon Approval", params: { id: item.id } });
    },
  },
};
</script>

<style></style>
